
import axios from "axios";
export const baseurl = "https://happiemarketing.com/mobile_app_api/";
export const baseurl2 = "http://localhost:3001/";
export default async function ApiRequest(url, method, body, header, noloader = false) {
  let obj = {
  }
  if (header) {
    obj.headers = header;
  }
  let loaderdiv = document.getElementById("global-loader");
  try {
    loaderdiv.style.display = "flex";
    let ApiRequest;
    if (method === "GET")
      ApiRequest = await axios.get(baseurl + url, obj);
    else
      ApiRequest = await axios.post(baseurl + url, body, obj);
    if (ApiRequest.status !== 200) {
      loaderdiv.style.display = "none";
      return { status: "error", message: ApiRequest.statusText }
    }
    loaderdiv.style.display = "none";
    return ApiRequest.data;
  } catch (e) {
    console.log(e);
    loaderdiv.style.display = "none";
    return { status: "error", message: e.message };
  }
}
export async function ApiRequest2(url, method, body, header, noloader = false) {
  let obj = {
  }
  if (header) {
    obj.headers = header;
  }
  let loaderdiv = document.getElementById("global-loader");
  try {
    loaderdiv.style.display = "flex";
    let ApiRequest;
    if (method === "GET")
      ApiRequest = await axios.get(baseurl2 + url, obj);
    else
      ApiRequest = await axios.post(baseurl2 + url, JSON.parse(body), obj);
    if (ApiRequest.status !== 200) {
      loaderdiv.style.display = "none";
      return { status: "error", message: ApiRequest.statusText }
    }
    loaderdiv.style.display = "none";
    return ApiRequest.data;
  } catch (e) {
    console.log(e);
    loaderdiv.style.display = "none";
    return { status: "error", message: e.message };
  }
}